var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-header columns"},[_c('div',{staticClass:"container is-one-quarter column"},[_c('div',{staticClass:"notification is-primary is-large"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_vm._t("left")],2),_c('div',{staticClass:"right-slot column is-three-quarters"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }